import { CDN_DEV_URL, CDN_PROD_URL, Stage, findStageFromUrl } from '@zooplus/commons-lang';

const ENV_SHARED = {
  REACT_APP_BFF_EXTERNAL_API_URL: '/explore-bff-api/api',
  isLocalhost: ['localhost'].includes(window?.location?.host), // FYI add your custom local domains here
  // version: process.env.VERSION || '0.0.0',
};

const ENV_DEVELOPMENT = {
  ...ENV_SHARED,
  stage: 'dev' as Stage,
  CDN_URL: CDN_DEV_URL,
  isDev: true,
};

const ENV_PRODUCTION = {
  ...ENV_SHARED,
  stage: 'prod' as Stage,
  CDN_URL: CDN_PROD_URL,
  isDev: false,
};

// FYI you can provide more environment configuration on top of ENV_DEVELOPMENT & ENV_PRODUCTION if you need.
export const ENV = findStageFromUrl() === 'dev' ? ENV_DEVELOPMENT : ENV_PRODUCTION;
